"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Cross_exports = {};
__export(Cross_exports, {
  default: () => Cross_default
});
module.exports = __toCommonJS(Cross_exports);
var import_jsx_runtime = require("react/jsx-runtime");
const svgContent = (props, title, titleId, desc, descId) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
  "svg",
  __spreadProps(__spreadValues({}, props), {
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId,
    children: [
      desc ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("desc", { id: descId, children: desc }) : null,
      title ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          d: "M20.4853 19.0753L13.4142 12.0043L20.4853 4.93319C20.6728 4.74565 20.7782 4.4913 20.7782 4.22608C20.7782 3.96086 20.6728 3.70651 20.4853 3.51897C20.2977 3.33144 20.0434 3.22608 19.7782 3.22608C19.513 3.22608 19.2586 3.33144 19.0711 3.51897L12 10.59L4.92893 3.51897C4.7414 3.33144 4.48704 3.22608 4.22183 3.22608C3.95661 3.22608 3.70226 3.33144 3.51472 3.51897C3.32718 3.70651 3.22183 3.96086 3.22183 4.22608C3.22183 4.4913 3.32718 4.74565 3.51472 4.93319L10.5858 12.0043L3.51472 19.0753C3.32718 19.2629 3.22183 19.5172 3.22183 19.7824C3.22183 20.0476 3.32718 20.302 3.51472 20.4895C3.70226 20.6771 3.95661 20.7824 4.22182 20.7824C4.48704 20.7824 4.7414 20.6771 4.92893 20.4895L12 13.4185L19.0711 20.4895C19.2586 20.6771 19.513 20.7824 19.7782 20.7824C20.0434 20.7824 20.2977 20.6771 20.4853 20.4895C20.6728 20.302 20.7782 20.0476 20.7782 19.7824C20.7782 19.5172 20.6728 19.2629 20.4853 19.0753Z",
          fill: "currentColor"
        }
      )
    ]
  })
);
const SvgIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    desc,
    descId,
    iconSize,
    ariaHidden,
    color
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "desc",
    "descId",
    "iconSize",
    "ariaHidden",
    "color"
  ]);
  const sizes = {
    s: "12px",
    m: "16px",
    l: "24px",
    inherit: "inherit"
    // inherits size from parent
  };
  const size = sizes[iconSize] || "inherit";
  const style = {
    width: size,
    height: size,
    display: "flex",
    color
    // Use the color prop for the icon color
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "div",
    __spreadProps(__spreadValues({
      style,
      "aria-hidden": ariaHidden,
      id: descId ? descId : titleId
    }, props), {
      children: svgContent(props, title, titleId, desc, descId)
    })
  );
};
const SvgCross = SvgIcon;
var Cross_default = SvgCross;
//# sourceMappingURL=Cross.js.map